import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isManagerOrAdmin } from 'shared/domain/role/isManagerOrAdmin';
import { isStandard } from 'shared/domain/role/isStandard';
import { isViewer } from 'shared/domain/role/isViewer';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { MemoCreateContractWizardContainer } from 'views/contracts/wizard/create/container';
import { MemoEditContractWizardContainer } from 'views/contracts/wizard/edit/container';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';
export const AuthorizableCreateContractWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();
    const isCurrentUserStandardOrViewer = isStandard(role) || isViewer(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isManagerOrAdmin(role)}
        unauthorized={isCurrentUserStandardOrViewer}
        authorizedComponent={MemoCreateContractWizardContainer}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);

export const AuthorizableEditContractWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();
    const isCurrentUserStandardOrViewer = isStandard(role) || isViewer(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isManagerOrAdmin(role)}
        unauthorized={isCurrentUserStandardOrViewer}
        authorizedComponent={MemoEditContractWizardContainer}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
